import { useTranslation } from "react-i18next";

import Error500Logo from "src/core/assets/images/error500logo.svg?react";

export const Error500 = () => {
  const { t } = useTranslation();

  return (
    <div className="w-full flex flex-col items-center h-full pt-60px">
      <Error500Logo />
      <div className="mt-10 font-light text-red-error text-lg">{t("error.500")}</div>
    </div>
  );
};
